import { useSelector } from 'react-redux';

const useGetLoggedInUserDetails = () => {
  const loggedInUser = useSelector((state) => state.auth.userDetails);

  return loggedInUser;
};

export default useGetLoggedInUserDetails;
